import { render, staticRenderFns } from "./TarefaAprovacaoAlmoxarifadoModal.vue?vue&type=template&id=4fc42fa9"
import script from "./TarefaAprovacaoAlmoxarifadoModal.vue?vue&type=script&lang=js"
export * from "./TarefaAprovacaoAlmoxarifadoModal.vue?vue&type=script&lang=js"
import style0 from "./TarefaAprovacaoAlmoxarifadoModal.vue?vue&type=style&index=0&id=4fc42fa9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports